import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '@/App';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login', { replace: true });
          return;
        }

        // Clear the hash from URL to prevent re-processing on page refresh
        window.history.replaceState(null, '', window.location.pathname);

        // Exchange session_id for user data and session_token
        const response = await fetch(`${API}/auth/google/session`, {
          method: 'POST',
          headers: {
            'X-Session-ID': sessionId,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to authenticate');
        }

        const data = await response.json();
        
        // Store session token in localStorage (persists across tabs and browser sessions)
        localStorage.setItem('session_token', data.session_token);
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true,
          state: { user: data.user }
        });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center">
      <div className="text-gold-400 text-lg">Autenticando...</div>
    </div>
  );
}
